/*
  Neropos pages: what every page shares. The toast, the drawers (the menu here, the cart in np-cart.js), the loops
  that play while on screen, the box button that comes up while the page's own buy button is off the screen, the
  header over a dark part, and the questions' filter. The page's own scripts come after this one and use window.NP,
  which theme-data starts with the shop's money format, routes and texts.
  The design and its notes: themes/neropos/design/pages (pages.js there is the proposal's version of this file).
*/
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;
  root.classList.add('js');
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NP = window.NP || (window.NP = {});
  NP.$ = $; NP.$$ = $$; NP.reduce = reduce;

  /* Texts written from JavaScript come from the locale file ([name] placeholders); Shopify escapes them for HTML */
  var ENT = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&apos;': "'" };
  NP.tx = function (key, vars) {
    var s = ((NP.t && NP.t[key]) || '').replace(/&(amp|lt|gt|quot|#39|#x27|apos);/g, function (m) { return ENT[m] || m; });
    for (var k in vars || {}) s = s.split('[' + k + ']').join(vars[k]);
    return s;
  };
  // how long boxes last at this many washes a week: weeks below nine, then months
  NP.lasts = function (washes, wk) {
    var weeks = washes / wk;
    if (weeks < 9) { var w = Math.max(1, Math.floor(weeks)); return NP.tx(w === 1 ? 'weeks_one' : 'weeks_other', { n: w }); }
    return NP.tx('months', { n: Math.round(weeks / 4.345) });
  };

  /* The toast: one line that comes up from below and goes */
  var toastT = 0;
  NP.toast = function (msg) {
    var t = $('[data-toast]'); if (!t || !msg) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2800);
  };

  /* Drawers, the cart and the menu: cards that come in from below on a phone and from the side on a wider screen.
     Esc, a click outside, their close button or, on a phone, a pull down by the top closes them, and the focus goes
     back where it was. The toast moves into the one on top, so it shows over it */
  var drawers = [];
  function homeToast() {
    var t = $('[data-toast]'), top = null;
    if (!t) return;
    drawers.forEach(function (d) { if (d.dlg.open && d.dlg.classList.contains('is-open')) top = d.dlg; });
    top = top || document.body;
    if (t.parentNode !== top) top.appendChild(t);
  }
  // cls: on the page while it is open (the page under it stays still); onChange(open)
  NP.drawer = function (dlg, cls, onChange) {
    if (!dlg || !dlg.showModal) return null;
    var panel = $('[data-drawer-panel]', dlg), opener = null, closeT = 0, drag = null;
    var d = { dlg: dlg };
    d.isOpen = function () { return dlg.open; };
    d.open = function (from) {
      clearTimeout(closeT);
      if (!dlg.open) { opener = from || document.activeElement; dlg.showModal(); }
      // a browser without overflow: clip may still scroll the drawer to its focused «X»: back to the top at once
      dlg.scrollTop = 0; dlg.scrollLeft = 0;
      var i = drawers.indexOf(d); if (i > -1) drawers.splice(i, 1);
      drawers.push(d);
      root.classList.add(cls);
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); homeToast(); }); });
      var x = $('[data-close]', dlg); if (x) x.focus({ preventScroll: true });
      if (onChange) onChange(true);
    };
    // now === true: at once, for a link that takes the page somewhere
    d.close = function (now) {
      if (!dlg.open) return;
      clearTimeout(closeT);
      dlg.classList.remove('is-open'); root.classList.remove(cls); homeToast();
      var shut = function () {
        dlg.close(); homeToast();
        if (now !== true && opener && opener.focus && opener.isConnected) opener.focus({ preventScroll: true });
      };
      if (now === true || reduce) shut(); else closeT = setTimeout(shut, 300);
      if (onChange) onChange(false);
    };
    dlg.addEventListener('scroll', function () { if (dlg.scrollTop || dlg.scrollLeft) { dlg.scrollTop = 0; dlg.scrollLeft = 0; } });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); d.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) d.close(); });
    dlg.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) d.close(); });
    // on a phone the sheet goes back down when pulled by its top (the head is redrawn with the cart, so it is found
    // again on every pull)
    if (panel) {
      panel.addEventListener('pointerdown', function (e) {
        var head = e.target.closest('[data-drawer-head]');
        if (innerWidth >= 768 || !head || e.target.closest('button, a')) return;
        drag = { y: e.clientY, dy: 0, id: e.pointerId }; panel.style.transition = 'none'; panel.setPointerCapture(e.pointerId);
      });
      panel.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        drag.dy = Math.max(0, e.clientY - drag.y); panel.style.transform = 'translateY(' + drag.dy + 'px)';
      });
      var end = function () {
        if (!drag) return;
        var far = drag.dy > 90; drag = null;
        panel.style.transition = ''; panel.style.transform = '';
        if (far) d.close();
      };
      panel.addEventListener('pointerup', end); panel.addEventListener('pointercancel', end);
    }
    return d;
  };

  /* The menu: a drawer like the cart's, from the left on a wider screen */
  var burger = $('[data-burger]');
  var menu = NP.menu = NP.drawer($('[data-menu]'), 'menu-on', function (on) { if (burger) burger.setAttribute('aria-expanded', String(on)); });
  if (menu) {
    if (burger) burger.addEventListener('click', function () { menu.open(burger); });
    // a link that takes the page somewhere, or the bag (the cart comes after it): the menu goes at once
    $$('a[href], [data-open-cart]', menu.dlg).forEach(function (a) {
      a.addEventListener('click', function () { if (a.target !== '_blank') menu.close(true); });
    });
  }

  /* Loops: they load and play while on screen, never with reduced motion (then their posters stay) */
  // (the home plays its own: assets/np-home.js)
  var vids = $$('video[data-src]').filter(function (v) { return !v.closest('.home3'); });
  if (vids.length && 'IntersectionObserver' in window && !reduce) {
    var vo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.preload = 'auto'; }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { vo.observe(v); });
  }

  /* The box button: up while the page's own buy button is off the screen (gone up, still below it, or under the part
     that has risen over it), down over the parts that have buttons of their own and over the footer */
  // the part after the buy's own: Shopify wraps each section in a div of its own, so it is the next one of the list
  var bar = $('[data-bar]'), from = $('[data-bar-from]'), aways = $$('[data-bar-away]'), allParts = $$('[data-part]');
  var fromPart = from && from.closest('[data-part]'), overPart = fromPart ? allParts[allParts.indexOf(fromPart) + 1] || null : null;
  function paintBar() {
    if (!bar || !from) return;
    var vh = innerHeight, f = from.getBoundingClientRect(), on = f.bottom < 0 || f.top > vh;
    if (!on && overPart && overPart.offsetHeight && overPart.getBoundingClientRect().top < f.bottom) on = true;
    aways.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh - 40 && r.bottom > 0) on = false; });
    if (on !== bar.classList.contains('on')) { bar.classList.toggle('on', on); bar.inert = !on; }
  }
  addEventListener('scroll', paintBar, { passive: true }); addEventListener('resize', paintBar);
  NP.paintBar = paintBar;
  paintBar();

  /* The header: see-through with white words over a dark part (data-dark), a dark glass once the page has moved;
     see-through with dark words over a light scent's first screen (data-clear), a white glass once the page has moved;
     white over the other light parts. The part under it is the last one there (later parts lie over earlier ones),
     leaving out one that the next has covered whole: it is not drawn */
  // (the home paints it from its own scenes: assets/np-home.js)
  var hdr = $('.home3') ? null : $('[data-hdr]'), unders = $$('[data-part], .ftr'), hdrKey = '';
  function paintHeader() {
    if (!hdr) return;
    var y = hdr.offsetHeight / 2, over = null;
    unders.forEach(function (el) { if (!el.offsetHeight || (NP.covered && NP.covered(el))) return; var r = el.getBoundingClientRect(); if (r.top <= y && r.bottom > y) over = el; });
    var dark = !!(over && over.hasAttribute('data-dark')), clear = !dark && !!(over && over.hasAttribute('data-clear'));
    var glass = (dark || clear) && scrollY > 2, key = (dark ? 'd' : clear ? 'c' : 'l') + (glass ? 'g' : '');
    if (key === hdrKey) return;
    hdrKey = key; hdr.classList.toggle('on-dark', dark); hdr.classList.toggle('on-clear', clear); hdr.classList.toggle('glass', glass);
  }
  addEventListener('scroll', paintHeader, { passive: true }); addEventListener('resize', paintHeader);
  NP.paintHeader = paintHeader;
  paintHeader();

  /* Questions: the filter hides what does not match, and a topic with nothing left */
  var q = $('[data-faq-filter]');
  if (q) {
    var norm = function (s) {
      s = String(s || '').toLowerCase().normalize('NFD');
      var o = '';
      for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); if (c >= 768 && c <= 879) continue; o += c === 962 ? 'σ' : s.charAt(i); }
      return o;
    };
    q.addEventListener('input', function () {
      var v = norm(q.value.trim()), any = false;
      $$('[data-topic]').forEach(function (t) {
        var seen = 0;
        $$('details', t).forEach(function (d) { var hit = !v || norm(d.textContent).indexOf(v) > -1; d.hidden = !hit; if (hit) seen++; if (v && hit) d.open = true; if (!v) d.open = false; });
        t.hidden = !seen; if (seen) any = true;
      });
      var e = $('[data-faq-empty]'); if (e) e.hidden = any;
    });
  }
})();
